<template>
  <div id="side-bar">
    <ul>
      <li class="line-title" v-for="line in lineInfo" v-bind:key="line.properties['@id']">
        {{ formatLineTitle(line) }}
        <ul>
          <li class="line-prop" v-for="(prop, key) in formatLineProps(line.properties)" v-bind:key="prop['@id']">
            {{ key + ": " + prop}}
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'side-bar',
  props: [
    'lineInfo'
  ],
  methods: {
    formatLineTitle(line) {
      let name = line.properties.name;
      if (name.includes(':')) {
        name = name.split(':')[0];
      }
      return name;
    },
    formatLineProps(props) {

      let exclude = [
        '@id',
        'colour',
        'public_transport:version',
        'type',
        '@tainted',
        'network-guid',
        'wikidata',
        '@relations'
      ];

      exclude.forEach((key) => {
        delete props[key];
      });

      return props;
    }
  }
}
</script>

<style>
  #side-bar {
    float:left;
    width: 20%;
    height: 100%;
    border-right-width: 2px;
  }
  .line-title {
    font-weight: bold;
    list-style-type: none;
  }
  .line-prop {
    font-weight: normal;
    list-style-type: none;
  }
</style>